var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"value":_vm.text,"rules":_vm.allRules,"prefix":"€","outlined":""},on:{"input":_vm.onInput,"focus":function($event){_vm.focused = true},"blur":_vm.onBlur}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }